import { render, staticRenderFns } from "./DimensionsReport.vue?vue&type=template&id=13b10b0c&scoped=true"
import script from "./DimensionsReport.vue?vue&type=script&lang=js"
export * from "./DimensionsReport.vue?vue&type=script&lang=js"
import style0 from "./DimensionsReport.vue?vue&type=style&index=0&id=13b10b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b10b0c",
  null
  
)

export default component.exports